import { cn } from '@/lib/utils'

// The Lucide "pen" glyph (24 x 24) and the little cursive word its nib writes.
const PEN = 'M21.174 6.812a1 1 0 0 0-3.986-3.987L3.842 16.174a2 2 0 0 0-.5.83l-1.321 4.352a.5.5 0 0 0 .623.622l4.353-1.32a2 2 0 0 0 .83-.497z'
const INK = 'M1.4 31.6C3.19 31.38 6.89 28.69 7.22 25.55C7.5 23.09 6.22 21.97 5.1 22.42C3.75 22.98 3.53 26.67 4.2 28.91C4.65 30.59 5.54 31.66 6.78 31.6C8.12 31.54 8.68 27.79 9.91 27.79C11.03 27.79 10.92 31.38 12.15 31.38C13.05 31.38 13.72 30.37 14.17 29.25'

/** The Create pen while a reply is being written: it writes a small cursive word, lifts, and writes it again.
 *  The span is a 16px icon box (h-4 w-4); the pen and its ink draw a few px outside it, so the row does not move.
 *  Pass className to resize or recolour it (e.g. "h-5 w-5", "text-muted-foreground"). Styles: .pen-writing in globals.css. */
export function WritingPen({ className }: { className?: string }) {
  return (
    <span className={cn('pen-writing h-4 w-4 text-foreground', className)} aria-hidden="true">
      <svg className="pen-writing-svg" viewBox="0 0 30 36" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round">
        <path className="pen-writing-ink" d={INK} />
        <g className="pen-writing-pen">
          <path d={PEN} strokeWidth={2.33} transform="scale(0.86) translate(-2.1 -21.9)" />
        </g>
      </svg>
    </span>
  )
}
